export const descriptions = [
    { code: "HALL_1", greek: "HALL 1", english: "HALL 1" },
    { code: "HALL_2", greek: "HALL 2", english: "HALL 2" },
    { code: "HALL_3", greek: "HALL 3", english: "HALL 3" },
    { code: "MEC", greek: "MEC", english: "MEC" },
    { code: "MEC ΥΠΧ", greek: "MEC ΥΠΧ", english: null },
    { code: "Κορωνα", greek: "ΑΙΘΟΥΣΑ ΚΟΡΩΝΑ", english: "CORONA" },
    { code: "ΑΠΑΡ", greek: "ΑΙΘΟΥΣΑ ΠΟΛΛΑΠΛΩΝ ΧΡΗΣΕΩΝ \"ΑΙΜΙΛΙΟΣ ΡΙΑΔΗΣ\"", english: "RIADIS" },
    { code: "Π1ΑΛΒ", greek: "ΑΛΒΑΝΙΑ ΠΕΡ 1 ΙΣΟΓΕΙΟ", english: null },
    { code: "ΔΕΚ", greek: "ΔΕΚΑΜΑΘ", english: null },
    { code: "LEVEL- A", greek: "ΕΠΙΠΕΔΟ A", english: "LEVEL A" },
    { code: "LEVEL-B", greek: "ΕΠΙΠΕΔΟ B", english: "LEVEL B" },
    { code: "LEVEL-C", greek: "ΕΠΙΠΕΔΟ C", english: "LEVEL C" },
    { code: "LEVEL-D", greek: "ΕΠΙΠΕΔΟ D", english: "LEVEL D" },
    { code: "ΕΣΚΑ-E", greek: "ΕΠΙΠΕΔΟ Ε", english: "LEVEL E" },
    { code: "ΒΕΛΛΙΔΗΣ", greek: "Ι. ΒΕΛΛΙΔΗΣ", english: "I.Vellidis" },
    { code: "ΜΚ", greek: "ΜΕΜΟΝΩΜΕΝΑ ΚΤΙΡΙΑ", english: null },
    { code: "Π01ΙΣ", greek: "ΠΕΡΙΠΤΕΡΟ 01 ΙΣΟΓΕΙΟ", english: "PAVILION 01 GROUND FLOOR" },
    { code: "Π01ΟΡ", greek: "ΠΕΡΙΠΤΕΡΟ 01 ΟΡΟΦΟΣ", english: "PAVILION 01 FLOOR" },
    { code: "Π02ΙΣ", greek: "ΠΕΡΙΠΤΕΡΟ 02 ΙΣΟΓΕΙΟ", english: "PAVILION 02 GROUND FLOOR" },
    { code: "Π02ΟΡ", greek: "ΠΕΡΙΠΤΕΡΟ 02 ΟΡΟΦΟΣ", english: "PAVILION 02 FLOOR" },
    { code: "Π03", greek: "ΠΕΡΙΠΤΕΡΟ 03", english: "PAVILION 03" },
    { code: "Π04", greek: "ΠΕΡΙΠΤΕΡΟ 04", english: "PAVILION 04" },
    { code: "Π04Α", greek: "ΠΕΡΙΠΤΕΡΟ 04Α", english: "PAVILION 04A" },
    { code: "Π05", greek: "ΠΕΡΙΠΤΕΡΟ 05", english: "PAVILION 05R" },
    { code: "Π06", greek: "ΠΕΡΙΠΤΕΡΟ 06", english: "PAVILION 06" },
    { code: "Π07ΙΣ", greek: "ΠΕΡΙΠΤΕΡΟ 07 ΙΣΟΓΕΙΟ", english: "PAVILION 07 GROUND FLOOR" },
    { code: "Π07ΟΡ", greek: "ΠΕΡΙΠΤΕΡΟ 07 ΟΡΟΦΟΣ", english: "PAVILION 07 FLOOR" },
    { code: "Π08ΙΣ", greek: "ΠΕΡΙΠΤΕΡΟ 08 ΙΣΟΓΕΙΟ", english: "PAVILION 08 GROUND FLOOR" },
    { code: "Π08ΟΡ", greek: "ΠΕΡΙΠΤΕΡΟ 08 ΟΡΟΦΟΣ", english: "PAVILION 08 FLOOR" },
    { code: "Π09ΙΣ", greek: "ΠΕΡΙΠΤΕΡΟ 09 ΙΣΟΓΕΙΟ", english: "PAVILION 09 GROUND FLOOR" },
    { code: "Π09ΟΡ", greek: "ΠΕΡΙΠΤΕΡΟ 09 ΟΡΟΦΟΣ", english: "PAVILION 09 FLOOR" },
    { code: "Π10", greek: "ΠΕΡΙΠΤΕΡΟ 10", english: "PAVILION 10" },
    { code: "ΠΕΡ 11", greek: "ΠΕΡΙΠΤΕΡΟ 11", english: "PAVILION 11" },
    { code: "Π12ΙΣ", greek: "ΠΕΡΙΠΤΕΡΟ 12 ΙΣΟΓΕΙΟ", english: "PAVILION 12 GROUND FLOOR" },
    { code: "Π12ΟΡ", greek: "ΠΕΡΙΠΤΕΡΟ 12 ΟΡΟΦΟΣ", english: "PAVILION 12 FLOOR" },
    { code: "Π13", greek: "ΠΕΡΙΠΤΕΡΟ 13", english: "PAVILION 13" },
    { code: "Π14", greek: "ΠΕΡΙΠΤΕΡΟ 14", english: "PAVILION 14" },
    { code: "Π14ΛΙΑΝ", greek: "ΠΕΡΙΠΤΕΡΟ 14 ΛΙΑΝΙΚΕΣ", english: "PAVILION 14 RETAIL SALES" },
    { code: "Π15ΙΣ", greek: "ΠΕΡΙΠΤΕΡΟ 15 ΙΣΟΓΕΙΟ", english: "PAVILION 15 GROUND FLOOR" },
    { code: "Π15ΟΡ", greek: "ΠΕΡΙΠΤΕΡΟ 15 ΟΡΟΦΟΣ", english: "PAVILION 15 FLOOR" },
    { code: "Π16ΙΣ", greek: "ΠΕΡΙΠΤΕΡΟ 16 ΙΣΟΓΕΙΟ", english: "PAVILION 16 GROUND FLOOR" },
    { code: "Π16ΟΡ", greek: "ΠΕΡΙΠΤΕΡΟ 16 ΟΡΟΦΟΣ", english: "PAVILION 16 FLOOR" },
    { code: "Π17", greek: "ΠΕΡΙΠΤΕΡΟ 17", english: "PAVILION 17" },
    { code: "ΠΕΡ-Α", greek: "ΠΕΡΙΠΤΕΡΟ A", english: "PAVILION A" },
    { code: "ΠΕΡ-Β", greek: "ΠΕΡΙΠΤΕΡΟ B", english: "PAVILION" },
    { code: "ΠΕΡ-C", greek: "ΠΕΡΙΠΤΕΡΟ C", english: "PAVILION C" },
    { code: "Π1ΣΚΟ", greek: "ΣΚΟΠΙΑ ΠΕΡΙΠΤΕΡΟ 1", english: null },
    { code: "ΣΧ", greek: "ΣΤΕΓΑΣΜΕΝΟΙ ΧΩΡΟΙ", english: "COVERED AREAS" },
    { code: "ΣΑ", greek: "ΣΥΝΔΥΑΣΜΟΙ ΑΙΘΟΥΣΩΝ", english: null },
    { code: "ΣΚΙΒ", greek: "ΣΥΝΕΔΡΙΑΚΟ ΚΕΝΤΡΟ \"ΙΩΑΝΝΗΣ ΒΕΛΛΙΔΗΣ\"", english: "I. VELLIDIS" },
    { code: "ΣΚΝΓ", greek: "ΣΥΝΕΔΡΙΑΚΟ ΚΕΝΤΡΟ \"ΝΙΚΟΛΑΟΣ ΓΕΡΜΑΝΟΣ\"", english: "N. GERMANIS" },
    { code: "ΤΕΑ", greek: "ΤΕΝΤΑ Α", english: "TENT A" },
    { code: "ΤΕΒ", greek: "ΤΕΝΤΑ Β", english: null },
    { code: "ΤΟΜ-1", greek: "ΤΟΜΕΑΣ 1", english: "SECTOR 1" },
    { code: "ΤΟΜ-2", greek: "ΤΟΜΕΑΣ 2", english: "SECTOR 2" },
    { code: "ΤΟΜ-3", greek: "ΤΟΜΕΑΣ 3", english: "SECTOR 3" },
    { code: "ΥΧ-1", greek: "ΥΠΑΙΘΡΙΟΣ ΧΩΡΟΣ", english: "OPEN AIR SPACE" },
    { code: "ΥΧ-2", greek: "ΥΠΑΙΘΡΙΟΣ ΧΩΡΟΣ", english: "OPEN AIR SPACE" }
];